<div style="padding-top:50px">

  <iframe width="100%" height="700" [src]="EmbededURL | safe" frameborder="0" allowFullScreen="true"></iframe>
</div>
